/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CourseModuleContentAccessDetail } from './courseModuleContentAccessDetail';

export interface CourseModuleContent {
  active?: boolean;
  contentId?: number;
  contentOrder?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  description?: string;
  image?: string;
  length?: number;
  moduleId?: number;
  subtitle?: string;
  title?: string;
  videoURL?: string;
  views?: Array<CourseModuleContentAccessDetail>;
}
